export type AnonymityConfig = {
  isAnonymityEnabled: boolean
  isAnonymityPreselected: boolean
}

export type FormAnonymity = AnonymityConfig & {
  /** `null` until the reporter touches the toggle. */
  choice: boolean | null
}

export const resolveIsAnonymous = ({
  choice,
  isAnonymityEnabled,
  isAnonymityPreselected,
}: FormAnonymity) => isAnonymityEnabled && (choice ?? isAnonymityPreselected)
